import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDocuments } from "../../hooks/useDocuments";
import { useClient } from "../../hooks/useClient";
import { toast } from "react-toastify";
import ReactLoading from "react-loading";
import ErrorMessage from "../../components/shared/ErrorMessage";
import Header from "../../components/header/header.js";
import Signature from "../../components/signature/signature.js";
import styles from "./FormSigner.module.css";
import PdfModal from "../../components/pdfModal/pdfModal.js";

function FormSigner() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const { clientData, clientError, clientIsLoading } = useClient();
  const { emailMarinaAuthorization, fetchMarinaAuthorization } = useDocuments();

  const [ emailSent, setEmailSent ] = useState(false);
  const [userData, setUserData] = useState({
    name: "",
    mailingAddress: "",
    propertyAddress: "",
    emailAddress: "",
    signature: "",
  });

  // Prefill userData from search params on mount
  useEffect(() => {
    const name = searchParams.get("name") || "";
    const mailingAddress = searchParams.get("mailingAddress") || "";
    const propertyAddress = searchParams.get("propertyAddress") || "";
    const emailAddress = searchParams.get("emailAddress") || "";
    const signature = searchParams.get("signature") || "";

    setUserData({ name, mailingAddress, propertyAddress, emailAddress, signature });
  }, [searchParams]);

  const openPdf = async () => {
    try {
      const url = await fetchMarinaAuthorization(); // returns blob URL

      console.log("Opening PDF URL:", url);

      // Open PDF in a new tab
      window.open(url, "_blank");
    } catch (error) {
      console.error("Failed to open PDF:", error);
    }
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSendAuthorizationEmail = async (payload) => {
    return toast.promise(
      emailMarinaAuthorization.mutateAsync(payload),
      {
        pending: "Sending authorization email...",
        success: "Authorization email sent successfully!",
        error: "Failed to send authorization email.",
      }
    );
  };


  const handleSubmitForm = async (data, signatureDataUrl) => {
    if (!signatureDataUrl) return;

    try {
      await handleSendAuthorizationEmail({
        name: data.name,
        mailingAddress: data.mailingAddress,
        propertyAddress: data.propertyAddress,
        emailAddress: data.emailAddress,
        signature: signatureDataUrl,
      });

      setEmailSent(true); // only after success
    } catch (err) {
      console.error("Email failed:", err);
    }
  };


  

  
  if (clientIsLoading) {
    return <div className="centering-container"><ReactLoading type="spin" color="#000" /></div>;
  }

  if (clientError) {
    return (
      <div className="centering-container">
        <ErrorMessage 
          title="Oops! Unable to Load"
          error="Please return to the homepage."
          linkText="Back to Home"
          command={() => navigate(-1)}
        />
      </div>
    );
  }

  if (emailSent) {
    return (
        <div className="centering-container">
          <ErrorMessage
            title="Thank You!"
            error="The marina authorization form has been sent successfully."
          />
        </div>
      );
  }

  return (
    <>
      

      <div className={styles.page}>
      <Header
        name={clientData.companyName}
        websiteUrl={clientData.website}
        logoUrl={clientData.logo}
      />

      
      <div className={styles.content}>


        <section className="section">
          <form className={styles.form} onSubmit={(e) => { e.preventDefault(); }}>
            <h2 className={styles.heading}>BoatTorch Authorization Form</h2>

            <p className={styles.paragraph}>
              Please complete and sign the form below to authorize us to use our private dock for our pontoon rental, and that our dock is not located within your Riparian Rights Interest Area.
            </p>

            <button onClick={() => openPdf()}>Preview Form</button>   
            <br /><br />         

            <div className="mb-3">
              <label className="form-label">Property Owner Name</label>
              <input type="text" className="form-control" value={userData.name} onChange={handleChange} name="name" required/>
            </div>

            <div className="mb-3">
              <label className="form-label">Property Address</label>
              <input type="text" className="form-control" value={userData.propertyAddress} onChange={handleChange} name="propertyAddress" required/>
            </div>

            <div className="mb-3">
              <label className="form-label">Mailing Address</label>
              <input type="text" className="form-control" value={userData.mailingAddress} onChange={handleChange} name="mailingAddress" required/>
            </div>

            <div className="mb-3">
              <label className="form-label">Email Address</label>
              <input type="email" className="form-control" value={userData.emailAddress} onChange={handleChange} name="emailAddress" required/>
            </div>
            
            <div className="mb-3 mx-auto text-center" style={{ maxWidth: "400px" }}>
              <label className="form-label">Signature</label>
              <Signature
                onSubmit={(signatureDataUrl) => handleSubmitForm(userData, signatureDataUrl)}
              />
            </div>

          </form>
          </section>
      </div>
      </div>

    </>
  );
};

export default FormSigner;